import React, {useState} from 'react'
import { SelectInline, InputInline } from '@arnsbogroup/react-voicearchive'

const FileSettings = ( {customer, onChange} ) => {
  if (!customer) {
    return null
  }

  const [convention, setConvention] = useState(customer.filenameConvention);

  const fileNaming = {
    "system": "{task.supplier.userid}-{task.title}-{task.filenumber}.{file.ext}",
    "original": "{file.title}.{file.ext}",
    "custom": "",
  }

  function getFileNameOptions() {
    return [
      { value: 'system', label: 'System' },
      { value: 'original', label: 'Original' },
      { value: 'custom', label: 'Custom' },
    ]
  }

  function getPreset() {
    const options = getFileNameOptions();
    if (convention === fileNaming.system || convention === `/${fileNaming.system}`) {
      return options.find(option => option.value === 'system');
    } else if (convention === fileNaming.original || convention === `/${fileNaming.original}`) {
      return options.find(option => option.value === 'original');
    } else {
      return options.find(option => option.value === 'custom');
    }
  }

  function changeFilenameConventionHandler(value) {
    setConvention(value);
    
    fetch(`/rest/v2/customer/filenameConvention?customerId[]=${customer.uid}`,
    {
      method: 'PUT',
      body: JSON.stringify({filename: value}),
    })
      .then(() => {
        onChange(customer, true); // force refresh to fetch new updated file name convention
      });
  }


  return (
    <div className='p-4'>
      <div className='mb-6'>
        <SelectInline
          labelClassName="text-xs"
          label="Automatically deliver ALL supplier files"
          placeholder="Automatically deliver ALL supplier files"
          value={ { value: customer.allowAutoDelivery, label: (customer.allowAutoDelivery == '1') ? 'Yes' : 'No' } }
          options={[
            { value: '1', label: 'Yes' },
            { value: '0', label: 'No' },
          ]}
          onChange={(selection) => { onChange({ ...customer, allowAutoDelivery: selection.value }) } } 
        />
      </div>

      <div className='mb-2'>
        <h1>File Naming convention for customer files</h1>

        <div className='my-4'>
          <SelectInline
            labelClassName="text-xs"
            label="File naming preset"
            placeholder="File naming preset"
            value={ getPreset() }
            options={getFileNameOptions()}
            onChange={(selection) => {
              changeFilenameConventionHandler(fileNaming[selection.value]);
            } } 
          />
        </div>

        <div className="mb-4">
          <InputInline 
            labelClassName="text-xs"
            label="File naming convention"
            placeholder="File naming convention"
            value={ convention }
            onChange={({ target: { value } }) => {
              changeFilenameConventionHandler(value);
            }}
          />
        </div>
        
      </div>

      <div>
        <table>
          <tr>
              <td>&#123;order.title&#125;</td>
              <td>Title of the order</td>
          </tr>
          <tr>
              <td>&#123;order.uid&#125;</td>
              <td>Numeric id of the order</td>
          </tr>
          <tr>
              <td>&#123;task.title&#125;</td>
              <td>Title of the task</td>
          </tr>
          <tr>
              <td>&#123;task.uid&#125;</td>
              <td>Numeric id of the task</td>
          </tr>
          <tr>
              <td>&#123;task.supplier.userid&#125;</td>
              <td>Public name (userid) of the supplier</td>
          </tr>
          <tr>
              <td>&#123;task.filenumber&#125;</td>
              <td>Sequential number - starting from 0 and allways unique for each file in a collection</td>
          </tr>
          <tr>
              <td>&#123;file.ext&#125;</td>
              <td>The original file extension</td>
          </tr>
          <tr>
              <td>&#123;file.title&#125;</td>
              <td>The original filename (without the extension) use this to force the original name</td>
          </tr>
          <tr>
              <td>&#123;file.uid&#125;</td>
              <td>Numeric id of the file</td>
          </tr>
        </table>
      </div>
    </div>
  )
}

export default FileSettings
